/**
 * Calculate distance between two geographical points using Haversine formula
 * @param {number} lat1 - Latitude of point 1
 * @param {number} lon1 - Longitude of point 1
 * @param {number} lat2 - Latitude of point 2
 * @param {number} lon2 - Longitude of point 2
 * @returns {number} Distance in kilometers
 */
export const calculateDistance = (lat1, lon1, lat2, lon2) => {
    const R = 6371; // Earth's radius in kilometers
    const dLat = toRadians(lat2 - lat1);
    const dLon = toRadians(lon2 - lon1);

    const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(toRadians(lat1)) *
        Math.cos(toRadians(lat2)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = R * c;

    return distance;
};

const toRadians = (degrees) => {
    return degrees * (Math.PI / 180);
};

/**
 * Parse location string to extract coordinates
 * Handles various location formats from Firestore
 * @param {string|object} location - Event location data
 * @returns {{lat: number, lon: number}|null}
 */
export const parseEventLocation = (location) => {
    if (!location) return null;
    return { lat: location.coordinates.latitude, lon: location.coordinates.longitude };
};

/**
 * Filter events within a specified radius from user location
 * @param {Array} events - Array of event objects
 * @param {object} userCoords - User coordinates {lat, lon}
 * @param {number} radiusKm - Radius in kilometers (default: 50)
 * @returns {Array} Filtered events within radius
 */
export const filterEventsByDistance = (events, userCoords, radiusKm = 50) => {
    if (!userCoords || !events) return [];

    return events.filter(event => {
        const eventCoords = parseEventLocation(event.eventLocation);
        if (!eventCoords) return false;

        const distance = calculateDistance(
            userCoords.lat,
            userCoords.lon,
            eventCoords.lat,
            eventCoords.lon
        );

        console.log("Event: ", event.name);
        console.log("distance: ", distance);
        console.log("userLat: ", userCoords.lat);
        console.log("userLon: ", userCoords.lon);


        return distance <= radiusKm;
    });
};
